import React, { useState, useEffect } from 'react';
import Helper from '@/utils/helper';
import ConfirmAction from '@/components/modals/confirm-action';

export interface DraftRecoveryPromptProps {
    open: boolean;
    onRestore: () => void;
    onDiscard: () => void;
}

function DraftRecoveryPrompt({ open, onRestore, onDiscard }: DraftRecoveryPromptProps) {
    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

    useEffect(() => {
        if (open) {
            setConfirmOptions({
                ...Helper.initialiseConfirmOptions(),
                display: true,
                heading: 'Resume where you left off?',
                text: 'You have unsaved changes from a previous session on this form.',
                confirmButtonText: 'Restore',
                onConfirm: onRestore,
                showCancel: false,
                showDiscard: true,
                discardButtonText: 'Discard',
                onDiscard,
            });
        }
    }, [open, onRestore, onDiscard]);

    if (!open) return null;
    return <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />;
}

export default DraftRecoveryPrompt;
